export default __webpack_public_path__ + "static/media/OPD_CARD_V1.e5c15e92.png";